import type { InitOptions } from 'i18next';

import { i18nLanguages } from './types';

/**
 * The list of namespaces we use in the locales. Currently we only have one, but this
 * is here to support future expansion.
 *
 * Namespace files are stored in `packages/hub/public/locales/{language}/{namespace}.json`
 */
export const i18nNamespaces = ['common'] as const;

/**
 * The base `i18next` configuration shared between the Hub server and React app.
 * Individual implementations can extend this as needed.
 */
export const i18nInitConfig: InitOptions = {
  // debug: true,
  fallbackLng: 'en',
  supportedLngs: i18nLanguages,
  ns: i18nNamespaces,
  defaultNS: 'common' satisfies (typeof i18nNamespaces)[number],
};
